var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { merge } from 'lodash-es';
let SdsTdBase = (() => {
    var _a, _SdsTdBase_value_accessor_storage, _SdsTdBase_lines_accessor_storage, _SdsTdBase_ellipsis_accessor_storage;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _lines_decorators;
    let _lines_initializers = [];
    let _lines_extraInitializers = [];
    let _ellipsis_decorators;
    let _ellipsis_initializers = [];
    let _ellipsis_extraInitializers = [];
    return _a = class SdsTdBase extends _classSuper {
            /**
             * Value of data cell
             * @attr
             */
            get value() { return __classPrivateFieldGet(this, _SdsTdBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsTdBase_value_accessor_storage, value, "f"); }
            /**
             * The number of lines to display in the table cell.
             * Controls text truncation behavior in the table cell.
             *
             * @attr
             * @default 1
             */
            get lines() { return __classPrivateFieldGet(this, _SdsTdBase_lines_accessor_storage, "f"); }
            set lines(value) { __classPrivateFieldSet(this, _SdsTdBase_lines_accessor_storage, value, "f"); }
            /**
             * If true overlapping text will be represented as popover and ellipsis will be put instead.
             * @attr
             */
            get ellipsis() { return __classPrivateFieldGet(this, _SdsTdBase_ellipsis_accessor_storage, "f"); }
            set ellipsis(value) { __classPrivateFieldSet(this, _SdsTdBase_ellipsis_accessor_storage, value, "f"); }
            getClasses() {
                return classMap(merge({
                    'sds-td': true,
                    'sds-td--ellipsis': this.ellipsis,
                }, this.getCustomClasses()));
            }
            getCustomClasses() {
                return {};
            }
            constructor() {
                super(...arguments);
                _SdsTdBase_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, ''));
                _SdsTdBase_lines_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _lines_initializers, void 0)));
                _SdsTdBase_ellipsis_accessor_storage.set(this, (__runInitializers(this, _lines_extraInitializers), __runInitializers(this, _ellipsis_initializers, false)));
                __runInitializers(this, _ellipsis_extraInitializers);
            }
        },
        _SdsTdBase_value_accessor_storage = new WeakMap(),
        _SdsTdBase_lines_accessor_storage = new WeakMap(),
        _SdsTdBase_ellipsis_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({ type: String })];
            _lines_decorators = [property({ type: Number, reflect: true })];
            _ellipsis_decorators = [property({ type: Boolean })];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _lines_decorators, { kind: "accessor", name: "lines", static: false, private: false, access: { has: obj => "lines" in obj, get: obj => obj.lines, set: (obj, value) => { obj.lines = value; } }, metadata: _metadata }, _lines_initializers, _lines_extraInitializers);
            __esDecorate(_a, null, _ellipsis_decorators, { kind: "accessor", name: "ellipsis", static: false, private: false, access: { has: obj => "ellipsis" in obj, get: obj => obj.ellipsis, set: (obj, value) => { obj.ellipsis = value; } }, metadata: _metadata }, _ellipsis_initializers, _ellipsis_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsTdBase };
